<div class="flex flex-col h-[82vh] bg-gray-50 dark:bg-gray-900">
  <div
    class="p-4 bg-purple-600 text-white flex items-center justify-between sticky top-0 z-10"
  >
    <div class="flex items-center space-x-3">
      <button class="md:hidden text-white text-xl" (click)="handleGoBack()">
        ←
      </button>

      <img
        [src]="contact().avatar?.path ?? '/images/user_image.png'"
        class="w-10 h-10 rounded-full"
        alt="Avatar"
      />
      <div>
        <h3 class="text-lg font-bold">{{ contact().name }}</h3>
        <p class="text-sm" *ngIf="isContactTyping()">
          Digitando...
          <span class="inline-flex">
            <span class="loading loading-dots loading-sm"></span>
          </span>
        </p>
      </div>
    </div>
    <!-- <span *ngIf="onlineUsers.includes(conversation?.name ?? '')" class="text-green-400 text-xs">Online</span> -->
  </div>

  <div
    #messageContainer
    [scrollTop]="messageContainer.scrollHeight"
    class="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-red-400 scrollbar-track-gray-500 p-4 space-y-3 break-words"
  >
    @for (message of messages(); track $index){
    <div
      class="flex items-end space-x-2"
      [class.justify-end]="message.isOwn"
      [class.justify-start]="!message.isOwn"
    >
      @if(message.isOwn){
      <div class="flex items-center space-x-2">
        <div
          class="bg-blue-500 text-white p-3 rounded-lg shadow-md text-sm max-w-xs break-words transform"
        >
          <p>{{ message.content }}</p>
          <div class="text-xs opacity-70 mt-1 flex justify-end">
            <span>{{ message.createdAt | date : "shortTime" }}</span>
          </div>
          <div
            class="absolute -right-1 bottom-1 w-3 h-3 bg-blue-500 transform rotate-45"
          ></div>
        </div>
        <img
          [src]="userAvatar"
          class="w-8 h-8 rounded-full self-end ml-2"
          alt="Seu Avatar"
        />
      </div>
      } @else{
      <div class="flex items-center space-x-2">
        <img
          [src]="contact().avatar?.path ?? '/images/user_image.png'"
          class="w-8 h-8 rounded-full self-end mr-2"
          alt="Avatar"
        />
        <div
          class="bg-gray-300 text-white dark:bg-gray-700 dark:text-white p-3 rounded-lg shadow-md text-sm max-w-xs transform"
        >
          <p>{{ message.content }}</p>
          <div class="text-xs opacity-70 mt-1 flex justify-end">
            <span>{{ message.createdAt | relativeDate }}</span>
          </div>
          <div
            class="absolute -left-1 bottom-1 w-3 h-3 bg-gray-300 dark:bg-gray-700 transform rotate-45"
          ></div>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <div
    class="p-3 border-t flex items-center bg-white dark:bg-gray-800 sticky bottom-0 w-full"
  >
    <input
      [(ngModel)]="message"
      (input)="sendTypingEvent()"
      (keydown.enter)="sendMessage()"
      type="text"
      class="flex-1 p-2 border rounded-lg focus:outline-none dark:bg-gray-700 dark:text-white"
      placeholder="Digite sua mensagem..."
    />
    <button
      (click)="sendMessage()"
      class="ml-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
    >
      Enviar
    </button>
  </div>
</div>
